/* src/app/shared/components/error-page/error-page.component.scss */
.error_container {
  margin-left: 18%;
}
/*# sourceMappingURL=error-page.component.css.map */
